export const FETCH_ITEM_COUNT = 18;

export const MODE_GROUP_COLLECTIONS = {
  SIMPLE: 0,
  NORMAL: 1,
};

export const TYPE_COLLECTION = {
  POI: 'poi',
  FOLDER: 'folder',
};

export const TYPE_COLLECTIONS_LIST = {
  MYSELF: 'myself',
  SHARED: 'shared',
};
